import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Form, FormGroup, Field, CheckboxGroup, Checkbox, RadioGroup, Radio } from '@availity/form';
import '@availity/yup';
import { SelectField } from '@availity/select';
import Icon from '@availity/icon';
import { DateField } from '@availity/date';
import { Row, Col, Button, Label, UncontrolledTooltip } from 'reactstrap';
import * as yup from 'yup';
import moment from 'moment';
import PropTypes from 'prop-types';
import CurrencyInput from 'react-currency-input-field';
import { NavLink, Navigate } from 'react-router-dom';
import ReimbursementStore from '../stores/ReimbursementStore';
import withNavigate from '../../Common/components/withNavigate';
import MaskAmount from './MaskAmount';
import CustomProgressBar from '../CustomProgressBar/CustomProgressBar';


const categoryLimits = {
    'Household Goods and Furniture': { limit: 2500, message: 'Request for household goods and furniture Total cannot exceed $2,500.' },
    'Utility Set up Fees': { limit: 200, message: 'Request for utility set up fees Total cannot exceed $200.' },
    'Pantry Stocking': { limit: 500, message: 'Request for pantry stocking Total cannot exceed $500.' },
    'Arrears: Storage': { limit: 1500, message: '1,500 is the max as an allowable expenditure.' },
    'Arrears: Rental': { limit: 1500, message: '1,500 is the max as an allowable expenditure.' },
};
@observer
class ExpendituresInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            reInitialize: false,
            inValidAmount: false,
            atleastOneExpReqErrMsg: false,
            grandTotalExceedsLimit: false,
        };
    }

    componentDidMount() {
        if (window.performance) {
            if (performance.navigation.type == 1) {
                const contextPath = window.location.pathname;
                window.location.href = contextPath;
            }
        }
        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

    backNavigation = () => {
        const { navigate } = this.props;
        navigate('/reimbursementform');
    }

    setExpenditureCategory = value => {
        this.setState({ inValidAmount: false });
        if (ReimbursementStore.expenditureCategory === 'Pantry Stocking' || value == 'Pantry Stocking') {
            ReimbursementStore.setDietGuidelines([]);
        }
        if (
            ReimbursementStore.expenditureCategory === "First Month's Rent" ||
            value === "First Month's Rent"
        ) {
            ReimbursementStore.setRentalAssistance('');
        }
        ReimbursementStore.setExpenditureCategory(value);

    }

    setExpenditureDescription = value => {
        this.setState({ inValidAmount: false });
        ReimbursementStore.setExpenditureDescription(value);
    }

    setExpDescOtherDetails = event => {
        const { value } = event.target;
        ReimbursementStore.setExpDescOtherDetails(value);
    }

    onExpDescAmountChangeHandler = value => {
        const { expenditureCategory } = ReimbursementStore;
        const limitObj = categoryLimits[expenditureCategory];
        let currentTotal = 0;

        if (expenditureCategory && limitObj) {
            currentTotal = ReimbursementStore.expenditureDetails
                .filter(x => x.expenditureCategory === expenditureCategory)
                .reduce((sum, x) => sum + parseFloat(x.expenditureAmount || 0), 0);
        }
        const newTotal = currentTotal + (parseFloat(value) || 0);
        if (value && value > 0) {
            if (limitObj && newTotal > limitObj.limit) {
                this.setState({
                    inValidAmount: true,
                    limitErrorMessage: limitObj.message
                });
            } else {
                this.setState({
                    inValidAmount: false,
                    limitErrorMessage: ''
                });
            }
            ReimbursementStore.setExpDescAmount(value);
        } else {
            ReimbursementStore.setExpDescAmount('');
            this.setState({
                inValidAmount: true,
                limitErrorMessage: ''
            });
        }
    }

    checkExpDescAmount = value => {
        this.onExpDescAmountChangeHandler(value);
    }

    setExpDate = value => {
        ReimbursementStore.setExpDate(value);
    }

    setExpETP = event => {
        const { value } = event.target;
        ReimbursementStore.setExpETP(value);
    }

    addExpenditure = () => {
        ReimbursementStore.addExpenditureDetails();
        ReimbursementStore.resetSelectedExpenditureDetails();
        this.setState({ atleastOneExpReqErrMsg: false });
    }

    expenditures = (expenditureDetails, category) => {
        return (
            <>
                <hr />
                <Row className="label-font">
                    <Col className="pl-15" sm="6">
                        {`${category}: `} <b>{MaskAmount(ReimbursementStore.getSubTotalAmount(expenditureDetails, category))}</b>
                    </Col>
                </Row>
                {expenditureDetails.filter(x => x.expenditureCategory === category).map(exp => (
                    <Row className="mt-5 label-font" key={exp.expId}>
                        <Col className="pl-15" sm="2">
                            <div><b>Amount</b></div>
                            <div>{MaskAmount(exp.expenditureAmount)}</div>
                        </Col>
                        <Col className="pl-10" sm="2">
                            <div><b>Date</b></div>
                            <div>{moment(exp.expenditureDate).format("MM/DD/YYYY")}</div>
                        </Col>
                        <Col className="pl-10" sm="4">
                            <div><b>Description</b></div>
                            <div>{exp.expenditureDescription}</div>
                        </Col>
                        <Col className="pl-10" sm="4">
                            <div><b>Actions</b></div>
                            <button type="button" className="btn btn-link ml--15" onClick={() => this.onEditEventHandler(exp.expId)}>
                                <Icon name="pencil" size="lg" color="primary" />
                                Edit
                            </button>
                            <button type="button" className="btn btn-link ml--15" onClick={() => this.onDeleteEventHandler(exp.expId)}>
                                <Icon name="trash-empty" size="lg" color="primary" />
                                Delete
                            </button>
                        </Col>
                        {
                            exp.expenditureDescOtherDetails &&
                            <Col className="pl-15 pr-8 mb-4" sm="12">
                                <div><b>Other</b></div>
                                <div>{exp.expenditureDescOtherDetails}</div>
                            </Col>
                        }
                        {
                            exp.expenditureETP &&
                            <Col className="pl-15 pr-8" sm="12">
                                <div><b>ETP Narrative:</b></div>
                                <div>{exp.expenditureETP}</div>
                            </Col>
                        }
                    </Row>
                ))
                }
            </>
        );
    }

    onEditEventHandler = id => {
        ReimbursementStore.updateExp(id);
        document.getElementById("fcs-tap-heading").scrollIntoView();
        ReimbursementStore.delete(id);
    }

    onDeleteEventHandler = id => {
        ReimbursementStore.delete(id);
        ReimbursementStore.resetSelectedExpenditureDetails();
        this.setState({ atleastOneExpReqErrMsg: false });
    }

    setExpInfoNotes = event => {
        const { value } = event.target;
        ReimbursementStore.setExpInfoNotes(value)
    }

    rentalAssistance = value => {
        ReimbursementStore.setRentalAssistance(value);
    }

    dietguidelines = value => {
        ReimbursementStore.setDietGuidelines(value);
    }

    submit = () => {
        const { navigate } = this.props;
        const { expenditureDetails, expenditureAmount, expGrandTotalAmount } = ReimbursementStore;
        if (expGrandTotalAmount > 15000) {
            this.setState({ grandTotalExceedsLimit: true });
            return;
        }

        if (expenditureDetails.length > 0) {
            ReimbursementStore.resetSelectedExpenditureDetails();
            ReimbursementStore.setReimbursementPageStatus("#expendituresinfo", 'complete');
            navigate('/movingattestation');
        }
        else if (ReimbursementStore.expenditureCategory === "First Month's Rent" && ReimbursementStore.rentalAssistance === 'yes') {
            this.setState({ inValidAmount: false });
        } else if (!expenditureAmount) {
            this.setState({ inValidAmount: true });
        } else if (expenditureDetails.length === 0) {
            this.setState({ atleastOneExpReqErrMsg: true });
        }
    }


    render() {
        const {
            expenditureCategory,
            expenditureCategories,
            expenditureDescription,
            filteredExpDescriptions,
            expDescOtherDetails,
            expenditureAmount,
            expenditureDate,
            showExpETP,
            expenditureETP,
            expenditureDetails,
            expGrandTotalAmount,
            expInfoNotes,
            reimbursementFormPages,
            rentalAssistance,
            dietguidelines
        } = ReimbursementStore;

        const {
            inValidAmount,
            atleastOneExpReqErrMsg
        } = this.state;
        const limitObj = categoryLimits[expenditureCategory];
        const disableAddExpBtn = expenditureCategory === '' ||
            (expenditureCategory !== 'Pantry Stocking' && expenditureCategory !== 'Arrears: Rental' && expenditureCategory !== 'Arrears: Storage' && expenditureDescription === '')
            || expenditureAmount === '' || expenditureDate === ''
            || (expenditureCategory === 'Exception to Policy (ETP)' &&
                expenditureDescription === 'Other' && expDescOtherDetails === '')
            || (showExpETP && expenditureETP === '')
            || expenditureDetails.length > 9
            || (limitObj && expenditureAmount > limitObj.limit)
            || (expenditureCategory === 'Pantry Stocking' && (!dietguidelines || dietguidelines.length === 0))
            || (expenditureCategory === "First Month's Rent" && !rentalAssistance);

        return (
            <>
                <CustomProgressBar pages={reimbursementFormPages} page="#expendituresinfo" />
                <div className="border-form">
                    <small className="required-fields">*required</small>
                    <div className="spacer-48" />
                    <h2 className="poppinsH2" id="fcs-tap-heading">
                        Expenditure Information
                    </h2>
                    <div className="spacer-48" />
                    <Form
                        onSubmit={this.submit}
                        enableReinitialize
                        initialValues={{
                            expenditureCategory: expenditureCategory,
                            expenditureDescription: expenditureDescription,
                            expDescOther: expDescOtherDetails,
                            expDescAmount: expenditureAmount,
                            expDate: expenditureDate,
                            expETP: expenditureETP,
                            expGrandTotalAmount: expGrandTotalAmount,
                            rentalAssistance: rentalAssistance,
                            dietguidelines: dietguidelines
                        }}
                        validationSchema={yup.object().shape({
                            expenditureCategory:
                                expenditureDetails.length === 0 ?
                                    yup
                                        .string()
                                        .required('required!')
                                    :
                                    yup
                                        .string(),
                            rentalAssistance:
                                expenditureCategory === '' ?
                                    yup.string()
                                    : expenditureCategory === "First Month's Rent"
                                        ? yup.string().required('required!')
                                        : yup.string(),

                            expenditureDescription:
                                expenditureCategory === '' ?
                                    yup.string()
                                    : expenditureCategory === 'Pantry Stocking' || expenditureCategory === 'Arrears: Rental' || expenditureCategory === 'Arrears: Storage'|| (expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes')
                                        ? yup.string()
                                        : yup.string().required('required!'),
                            expDescOther:
                                ((expenditureCategory === 'Exception to Policy (ETP)' || expenditureCategory === 'Relocation expenses' || expenditureCategory === 'Household Goods and Furniture' || expenditureCategory === 'Utility Set up Fees' || expenditureCategory === 'Arrears: Utility' || expenditureCategory !== 'Arrears: Rental') && expenditureDescription === 'Other') ?
                                    yup.string().required('required!')
                                    :
                                    yup.string(),
                            expDate:
                                expenditureAmount === '' || (expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes') ?
                                    yup
                                        .string()
                                    :
                                    yup
                                        .date()
                                        .required('Date is required')
                                        .typeError('Date is invalid'),
                            expETP:
                                showExpETP ?
                                    yup
                                        .string()
                                        .required('required!')
                                    :
                                    yup
                                        .string(),
                        })}
                    >
                        <h5 className="poppinsH5">
                            Enter up to 10 FCS TAP expenditures for an FCS Supportive Housing enrollee.
                        </h5>
                        <div className="spacer-24" />
                        <Row>
                            <Col className="pl-15 max-width-20" sm="3">
                                <FormGroup for="expenditureCategory" className="label-font">
                                    <Label for="expenditureCategory">
                                        Category*
                                        <span id="expenditureCategory-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="expenditureCategory-help" placement="right"
                                        innerClassName="text-left">
                                        {`TAP funding category. Found on FCS TAP Quick Reference Guide`}
                                    </UncontrolledTooltip>
                                    <SelectField
                                        id="expCategory"
                                        name="expenditureCategory"
                                        className="straighten-borders pTypeList"
                                        value={expenditureCategory}
                                        onChange={this.setExpenditureCategory}
                                        options={expenditureCategories.map(expenditureCategory => (
                                            {
                                                value: expenditureCategory.value, label: expenditureCategory.name
                                            }
                                        ))}
                                        isDisabled={expenditureDetails.length > 9}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className={expenditureDescription === 'Other' ? "pl-10 max-width-20" : "pl-10 max-width-35"}>
                                {
                                    expenditureCategory === '' ||
                                        (['Arrears: Rental', 'Arrears: Storage'].includes(expenditureCategory)) ?
                                        <FormGroup for="expenditureDescription" className="label-font">
                                            <Label for="expenditureDescription">
                                                Description*
                                                <span id="expenditureDescription-help" className="inline-help" />
                                            </Label>
                                            <UncontrolledTooltip target="expenditureDescription-help" placement="right"
                                                innerClassName="text-left">
                                                {`TAP expenditure description. Found on FCS TAP Quick Reference Guide`}
                                            </UncontrolledTooltip>
                                            <SelectField
                                                name="expenditureDescription"
                                                className="straighten-borders pTypeList"
                                                value={expenditureDescription}
                                                onChange={this.setExpenditureDescription}
                                                options={filteredExpDescriptions.map(filteredExpDescription => (
                                                    {
                                                        value: filteredExpDescription.value, label: filteredExpDescription.name
                                                    }
                                                ))}
                                                isDisabled
                                            />
                                        </FormGroup>
                                        :
                                        <FormGroup for="expenditureDescription" className="label-font">
                                            <Label for="expenditureDescription">
                                                Description*
                                                <span id="expenditureDescription-help" className="inline-help" />
                                            </Label>
                                            <UncontrolledTooltip target="expenditureDescription-help" placement="right"
                                                innerClassName="text-left">
                                                {`TAP expenditure description. Found on FCS TAP Quick Reference Guide`}
                                            </UncontrolledTooltip>
                                            <SelectField
                                                name="expenditureDescription"
                                                className="straighten-borders pTypeList"
                                                value={expenditureDescription}
                                                onChange={this.setExpenditureDescription}
                                                options={filteredExpDescriptions.map(filteredExpDescription => (
                                                    {
                                                        value: filteredExpDescription.value, label: filteredExpDescription.name
                                                    }
                                                ))}
                                                isDisabled={expenditureCategory === 'Pantry Stocking' || (expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes')}
                                            />
                                        </FormGroup>
                                }
                            </Col>
                            {
                                (expenditureCategory === 'Exception to Policy (ETP)' &&
                                    expenditureDescription === 'Other') || (expenditureCategory === 'Relocation expenses' && expenditureDescription === 'Other') ||
                                    (expenditureCategory === 'Household Goods and Furniture' && expenditureDescription === 'Other') ||
                                    (expenditureCategory === 'Utility Set up Fees' && expenditureDescription === 'Other') ||
                                    (expenditureCategory === 'Arrears: Utility' && expenditureDescription === 'Other') ?
                                    <Col className="pl-10 max-width-20" sm="3">
                                        <FormGroup for="expDescOther" className="label-font">
                                            <Label for="expDescOther">
                                                Other*
                                            </Label>
                                            <Field
                                                type="text"
                                                id="expDescOther"
                                                name="expDescOther"
                                                className="straighten-borders"
                                                value={expDescOtherDetails}
                                                onChange={this.setExpDescOtherDetails}
                                                maxLength={500}
                                            />
                                        </FormGroup>
                                    </Col>
                                    : ''
                            }
                            <Col className="pl-10 max-width-15" sm="2">
                                <FormGroup for="expDescAmount" className="label-font">
                                    <Label for="expDescAmount" id="expDescAmountLabel">
                                        Amount*
                                        <span id="expDescAmount-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="expDescAmount-help" placement="right"
                                        innerClassName="text-left">
                                        {`TAP expenditure amount`}
                                    </UncontrolledTooltip>
                                    {
                                        expenditureCategory !== 'Pantry Stocking' &&
                                            expenditureCategory !== 'Arrears: Rental' &&
                                            expenditureCategory !== 'Arrears: Storage' &&
                                            (expenditureDescription === '' ||
                                                (expenditureDescription === 'Other' && expDescOtherDetails === '')) ?
                                            <CurrencyInput
                                                id="expDescAmount"
                                                name="expDescAmount"
                                                placeholder="$0.00"
                                                className="straighten-borders custom-amount-disabled"
                                                value={expenditureAmount}
                                                defaultValue={expenditureAmount}
                                                prefix="$"
                                                allowNegativeValue={false}
                                                decimalScale={2}
                                                onValueChange={this.onExpDescAmountChangeHandler}
                                                disabled
                                            />
                                            :
                                            <CurrencyInput
                                                id="expDescAmount"
                                                name="expDescAmount"
                                                placeholder="$0.00"
                                                className={expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes'
                                                    ? "straighten-borders custom-amount-disabled"
                                                    : (inValidAmount
                                                        ? "straighten-borders custom-amount is-touched av-invalid is-invalid is-invalid form-control"
                                                        : "straighten-borders custom-amount"
                                                    )}
                                                value={expenditureAmount}
                                                defaultValue={expenditureAmount}
                                                prefix="$"
                                                allowNegativeValue={false}
                                                decimalScale={2}
                                                onValueChange={this.onExpDescAmountChangeHandler}
                                                disabled={expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes'}


                                            />
                                    }
                                    {
                                        inValidAmount && (
                                            <div id="expDescAmount" className="invalid-exp-amount">
                                                {this.state.limitErrorMessage
                                                    ? this.state.limitErrorMessage
                                                    : "Amount is required"}
                                            </div>
                                        )
                                    }
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 max-width-15" sm="3">
                                <FormGroup for="expDate" className="label-font">
                                    <Label for="expDate" id="expDateLabel">
                                        Date*
                                        <span id="expDate-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="expDate-help" placement="right"
                                        innerClassName="text-left">
                                        {`Date of TAP expenditure`}
                                    </UncontrolledTooltip>
                                    <DateField
                                        type="text"
                                        id="expDate"
                                        name="expDate"
                                        className="straighten-borders"
                                        value={expenditureDate}
                                        onChange={this.setExpDate}
                                        openDirection='down'
                                        datePicker
                                        min={{ value: 99, units: 'year' }}
                                        max={{ value: 2, units: 'year' }}
                                        disabled={expenditureAmount === '' || inValidAmount || (expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes')}
                                    />
                                </FormGroup>
                            </Col>
                            {
                                showExpETP &&
                                expenditureCategory !== 'Household Goods and Furniture' &&
                                expenditureCategory !== 'Pantry Stocking' &&
                                expenditureCategory !== 'Security Deposits' &&
                                expenditureCategory !== 'First Month\'s Rent' &&
                                expenditureCategory !== 'Last Month\'s Rent' &&
                                expenditureCategory !== 'Arrears: Utility' &&
                                expenditureCategory !== 'Arrears: Storage' &&
                                expenditureCategory !== 'Arrears: Rental' &&
                                (
                                    <>
                                        <Col className="pl-15 mt-30 max-width-85" sm="11">
                                            <FormGroup for="expETP" className="label-font">
                                                <Label for="expETP">
                                                    {
                                                        expenditureCategory === 'Move-in assistance'
                                                            ?
                                                            'Any appropriate and reasonable non-refundable fees (Fees may be annualized) is $1500 and then anything over $1500 is an ETP. The fees are for when a client applies for housing and the landlord may have an admin fee for processing the application, or a fee to hold then unit etc.'
                                                            :
                                                            `An Exception to Policy (ETP) is required because the amount requested
                                exceeds the FCS TAP approved item amount.  Please describe why this expense
                                is a barrier to the enrollee's housing transition*`}
                                                </Label>
                                                <Field
                                                    type="textarea"
                                                    id="expETP"
                                                    name="expETP"
                                                    className={'textAreaHeightDetails straighten-borders form-control form-group label-font'}
                                                    value={expenditureETP}
                                                    onChange={this.setExpETP}
                                                    row="3"
                                                    col="200"
                                                    maxLength={500}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </>
                                )}
                            <Col className={showExpETP ? "pl-10 mt-98 max-width-13" : "pl-10 max-width-13"}>
                                <Button type="button" onClick={this.addExpenditure} color={"primary"}
                                    className={expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes'
                                        ? "addExpenditureBtn disabledBtn"
                                        : (disableAddExpBtn ?
                                            "btn btn-outline-primary addExpenditureBtn disabledBtn"
                                            :
                                            "btn btn-outline-primary addExpenditureBtn")}
                                    disabled={disableAddExpBtn || (expenditureCategory === "First Month's Rent" && rentalAssistance === 'yes')}
                                >
                                    Add Expenditure
                                </Button>
                            </Col>
                        </Row>

                        {expenditureCategory === "First Month's Rent" && (
                            <>
                                <div className="spacer-48" />
                                <Label className="criteria-header" htmlFor="rentalAssistance">
                                    Is the enrollee receiving any rental assistance through another program?*
                                </Label>
                                <div className="label-spacer-24" />
                                <FormGroup for="rentalAssistance" className="label-font">
                                    <RadioGroup
                                        name="rentalAssistance"
                                        value={rentalAssistance}
                                        onChange={this.rentalAssistance}
                                    >
                                        <Radio className="label-font mb-23" label="Yes" value="yes" />
                                        <Radio className="label-font mb-23" label="No" value="no" />
                                    </RadioGroup>
                                    {this.state.rentalAssistanceError && (
                                        <div className="invalid-exp-amount">{this.state.rentalAssistanceError}</div>
                                    )}
                                </FormGroup>
                            </>
                        )}
                        {
                            expenditureCategory === "First Month's Rent" &&
                            rentalAssistance === 'yes' && (
                                <Row>
                                    <Col sm="12">
                                        <div className="error-message">
                                            Only one funding source can be utilized for rental assistance. The enrollee is ineligible for first month's rental assistance through TAP due to receiving rental assistance from a different funding source.
                                        </div>
                                    </Col>
                                </Row>
                            )
                        }
                        {expenditureCategory === "Pantry Stocking" && (
                            <>
                                <div className="spacer-48" />
                                <CheckboxGroup name="dietguidelines" value={dietguidelines} onChange={this.dietguidelines}>
                                    <Checkbox
                                        label={
                                            <>
                                                I, the provider, attest that the enrollee has received the resources on the <a href="https://www.dietaryguidelines.gov/" target="_blank" rel="noopener noreferrer">Dietary Guidelines for Americans.</a>*
                                            </>
                                        }
                                        name="dietguidelines"
                                        className="label-font mb-24 no-display"
                                        groupName="dietguidelines"
                                        value="dietguidelines"
                                    />

                                </CheckboxGroup>
                            </>
                        )}
                        <div className="pb-spacerRem-2" />
                        {
                            expenditureDetails.length > 9 &&
                            <div className="danger-label-font">
                                <b>Only 10 FCS TAP expenditures are allowed!</b>
                            </div>
                        }
                        {
                            atleastOneExpReqErrMsg &&
                            <div className="danger-label-font">
                                <b>At least one expenditure detail is required. Please enter all the required details and click on the Add Expenditure button.</b>
                            </div>
                        }
                        <div className="pb-spacerRem-1" />

                        {expenditureDetails.filter(x => x.expenditureCategory === 'IDs and other documentation').length > 0 &&
                            this.expenditures(expenditureDetails, 'IDs and other documentation')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Application fees').length > 0 &&
                            this.expenditures(expenditureDetails, 'Application fees')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Transitional housing fees').length > 0 &&
                            this.expenditures(expenditureDetails, 'Transitional housing fees')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Relocation expenses').length > 0 &&
                            this.expenditures(expenditureDetails, 'Relocation expenses')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Move-in assistance').length > 0 &&
                            this.expenditures(expenditureDetails, 'Move-in assistance')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Exception to Policy (ETP)').length > 0 &&
                            this.expenditures(expenditureDetails, 'Exception to Policy (ETP)')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Security Deposits').length > 0 &&
                            this.expenditures(expenditureDetails, 'Security Deposits')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'First Month\'s Rent').length > 0 &&
                            this.expenditures(expenditureDetails, 'First Month\'s Rent')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Last Month\'s Rent').length > 0 &&
                            this.expenditures(expenditureDetails, 'Last Month\'s Rent')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Household Goods and Furniture').length > 0 &&
                            this.expenditures(expenditureDetails, 'Household Goods and Furniture')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Utility Set up Fees').length > 0 &&
                            this.expenditures(expenditureDetails, 'Utility Set up Fees')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Pantry Stocking').length > 0 &&
                            this.expenditures(expenditureDetails, 'Pantry Stocking')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Utility').length > 0 &&
                            this.expenditures(expenditureDetails, 'Arrears: Utility')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Rental').length > 0 &&
                            this.expenditures(expenditureDetails, 'Arrears: Rental')
                        }
                        {expenditureDetails.filter(x => x.expenditureCategory === 'Arrears: Storage').length > 0 &&
                            this.expenditures(expenditureDetails, 'Arrears: Storage')
                        }
                        {expGrandTotalAmount &&
                            <>
                                <hr />
                                <Row className="label-font">
                                    <Col className="pl-15" sm="6">
                                        {`Grand Total: `} <b>{MaskAmount(expGrandTotalAmount)}</b>
                                    </Col>
                                </Row>
                                {expGrandTotalAmount > 15000 && (
                                    <Row className="label-font">
                                        <Col className="pl-15" sm="6">
                                            <div className="error-message">Grand total of all expenditures exceeds the allowed limit of $15000. Please review your items and adjust or remove items to proceed.</div>
                                        </Col>
                                    </Row>
                                )}
                            </>
                        }
                        {
                            expenditureDetails.length > 0 &&
                            <>
                                <div className="spacer-48" />
                                <Row>
                                    <Col sm="6">
                                        <Label className="label-font" for="expInfoNotes">
                                            Notes
                                        </Label>
                                        <Field
                                            type="textarea"
                                            id="expInfoNotes"
                                            name="expInfoNotes"
                                            className={'textAreaHeightDetails straighten-borders form-control form-group label-font'}
                                            onChange={this.setExpInfoNotes}
                                            value={expInfoNotes}
                                            row="3"
                                            col="200"
                                            maxLength={2000}
                                        />
                                        <p className="small text-right mb-0 label-font">2000 Character max</p>
                                    </Col>
                                </Row>
                            </>
                        }
                        <div className="spacer-48" />
                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn mr-0"}>
                            Next
                        </Button>

                        <Button type="button" color={"primary"} className={'btn btn-primary backButton'} onClick={this.backNavigation}>
                            Back
                        </Button>
                        <div className="pb-spacerRem-10" />
                    </Form>
                </div >
            </>
        )
    }
}
export default withNavigate(ExpendituresInfo);

ExpendituresInfo.propTypes = {
    navigate: PropTypes.func,
};